import { FeatureFlag, useFeatureFlagValue } from "../../feature-flags";

/** LaunchDarkly gate for Agentic Platform nav and org workspace Agents tab. */
export function useAgenticPlatformEnabled(): boolean {
  return useFeatureFlagValue(FeatureFlag.EnableAgenticPlatform);
}
